import {
  canIUseCSSProperty
} from '../../utils/can-i-use'

export const extractIndexPosition = (position, index, dir = 'x') => {
  const indexPosition = Array.isArray(position) ? position[index] : position

  return typeof indexPosition[dir] === 'number'
    ? `${Math.round(indexPosition[dir])}px`
    : indexPosition[dir]
}

export const extractIndexTransformation = (position, index, {
  centerX,
  centerY
}) => {
  const isProvided = (val) => val !== null && val !== undefined

  const indexPosition = Array.isArray(position) ? position[index] : position

  // Apply horizontal transforms
  const _transforms = []
  if (centerX  && indexPosition.centerX !== false && !isProvided(indexPosition.translateX)) {
    canIUseCSSProperty('transform', 'translateX(calc(-50% - 0.5px))')
     ?  _transforms.push('translateX(calc(-50% - 0.5px))')
     : _transforms.push('translateX(-50%)')
  } else if (isProvided(indexPosition.translateX)) {
    _transforms.push(`translateX(${indexPosition.translateX})`)
  }

  // Apply vertical transforms
  if (centerY  && indexPosition.centerY !== false && !isProvided(indexPosition.translateY)) {
    canIUseCSSProperty('transform', 'translateY(calc(-50% - 0.5px))')
      ? _transforms.push('translateY(calc(-50% - 0.5px))')
      : _transforms.push('translateY(-50%)')
  } else if (isProvided(indexPosition.translateY)) {
    _transforms.push(`translateY(${indexPosition.translateY})`)
  }

  // Apply rotation
  if (isProvided(indexPosition.rotate)) {
    _transforms.push(`rotate(${indexPosition.rotate})`)
  }

  return _transforms.join(' ')
}